import TopBar from '../TopBar/TopBar'
import Sidebar from '../Sidebar/Sidebar'
import DocsComponent from './DocsComponent'

const DocsPage = () => {
    return (
        <>
            <TopBar />
            <div className='app-body'>
                <Sidebar />
                <div className='mainComponent'>
                    <DocsComponent />
                </div>
            </div>
        </>
    )
}

export default DocsPage

